import { createContext, ReactNode, useContext } from 'react';
import {
  CostServiceType,
  costService,
} from 'packages/lib/api/annotations-ops/clients/cost/cost-service';

// 2026-10-30 Used Cursor (Claude Opus 5.5) to add CostService dependency injection

const CostServiceContext = createContext<CostServiceType>(costService);

interface CostServiceProviderProps {
  service?: CostServiceType;
  children: ReactNode;
}

/** Supplies the Cost tool's API. Callers choose the implementation.
 * @param service an optional CostService override
 */
export function CostServiceProvider({
  service = costService,
  children,
}: CostServiceProviderProps) {
  return (
    <CostServiceContext.Provider value={service}>
      {children}
    </CostServiceContext.Provider>
  );
}

export const useCostService = (): CostServiceType =>
  useContext(CostServiceContext);
